import { render, staticRenderFns } from "./PageExpired.vue?vue&type=template&id=67a8c2c2&"
import script from "./PageExpired.vue?vue&type=script&lang=js&"
export * from "./PageExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports